import { ReviewAction, reviewReferral } from "api/admin/referrals";
import useAdminAccess from "hooks/useAdminAccess";
import { ActionForm, money } from "./shared";
export type Decision = { id: number; action: ReviewAction };
export const actionLabels = {
  "clear-hold": "Clear hold",
  reject: "Reject referral",
  reverse: "Reverse reward",
};
export default function ReferralActions({
  decision,
  done,
  cancel,
}: {
  decision: Decision;
  done: (message: string) => void;
  cancel: () => void;
}) {
  const { can } = useAdminAccess();
  const { id, action } = decision;
  return (
    <ActionForm
      key={`${id}-${action}`}
      title={`${actionLabels[action]} #${id}`}
      description={
        action === "clear-hold"
          ? "Clears the open fraud flags and rechecks eligibility. A qualified referral may be credited immediately, subject to its cycle cap and other checks."
          : action === "reject"
            ? "Rejects this pending referral as fraud. This decision is audited and the referrer is notified."
            : "Takes back the credited reward. Any amount already withdrawn becomes a lien on the referrer's fiat wallet."
      }
      allowed={can(
        action === "reverse"
          ? "referrals.rewards.approve"
          : "referrals.reviews.approve",
      )}
      cancel={cancel}
      done={done}
      run={async (reason) => {
        const result = await reviewReferral(id, action, reason);
        return action === "reverse" && result.currency
          ? `Reward reversed. Balance debited: ${money(result.balanceDebitedMinor ?? 0, result.currency)}. Wallet lien: ${money(result.walletLienMinor ?? 0, result.currency)}.`
          : `${actionLabels[action]} completed. Referral #${id} is ${result.status}.`;
      }}
    />
  );
}
